// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"848":"636203a3","2914":"5544a21f","6785":"dad34d86"}[chunkId] + ".chunk.css";
};